// extracted by mini-css-extract-plugin
export default {"about":"style_about__sJbAK","aboutTxt":"style_aboutTxt__qPvGL","aboutUni":"style_aboutUni__tP9GS","card":"style_card__Tdzql"};